import styled from 'styled-components';

const Container = styled.div``;

const HeaderActions = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  background-color: #fff;
  padding: 20px 30px;
  border-radius: 0 0 60px 0;
  box-shadow: 10px 10px 100px 10px rgba(0, 0, 0, 0.1);
`;

export default {
  Container,
  HeaderActions
};



// WEBPACK FOOTER //
// ./src/organisms/HeaderLeft/styles.js